import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import { history } from '@services/History'
import { clearStore } from '@/index.Dux'
import { getSelf } from '@modules/auth/auth.Dux'
import Consultations from '@services/Consultations'
import { clearServices } from '../../utilities/actions'

const DashboardProfile = () => {
  const self = useSelector((state) => getSelf(state))
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const signOut = async () => {
    try {
      await Consultations.auth.logout()
      dispatch(clearStore())
      clearServices()
      history.push('/')
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <div className="profile-wrapper">
      <div className="profile">
        <img className="profile-avatar" src={self.profile.avatar} alt="avatar" />
        <div className="profile-info">
          <div> {self.profile.name} </div>
          <button className="profile-close" onClick={() => signOut()}>
            {t('Cerrar sesión')}
          </button>
        </div>
      </div>
      <button className="password-change" onClick={() => history.push('/password')}>
        <span className="fas fa-cog" />
        {t('Cambiar Contraseña')}
      </button>
    </div>
  )
}
export default DashboardProfile
